<p-progress-spinner size="xxxlarge" ariaLabel="loading" animationDuration="1s" />
